import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { FitsTheAutoSchema } from '../types/fitsTheAutoSchema';
import { fetchFetMarksByParamTyres } from '../services/GetMarksByParamTyres';
import { fetchFetMarksByParamDisks } from '../services/GetMarksByParamDisks';

const initialState: FitsTheAutoSchema = {
  mark: {},
};

export const fitsTheAutoSlice = createSlice({
  name: 'fitsTheAuto',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.fitsTheAuto,
      };
    });
    builder.addCase(fetchFetMarksByParamTyres.fulfilled, (state, action) => {
      if (action.payload) {
        state.mark = action.payload;
      }
    });
    builder.addCase(fetchFetMarksByParamDisks.fulfilled, (state, action) => {
      if (action.payload) {
        state.mark = action.payload;
      }
    });
  },
});

export const { actions: fitsTheAutoActions } = fitsTheAutoSlice;
